import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/structure-type-selector.css';
const DEFAULT_STRUCTURE_TYPES = [
    {
        id: 'Pole',
        label: 'Pole',
        icon: 'fas fa-grip-lines-vertical',
        description: 'Telegraph or utility pole',
    },
    {
        id: 'Manhole',
        label: 'Manhole',
        icon: 'fas fa-square',
        description: 'Underground access chamber',
    },
    {
        id: 'JointBox',
        label: 'Joint Box',
        icon: 'fas fa-box',
        description: 'Cable junction box',
    },
    {
        id: 'TobyBox',
        label: 'Toby Box',
        icon: 'fas fa-house-user',
        description: 'Mini-chamber serving a premises',
    },
    {
        id: 'CTB',
        label: 'CTB',
        icon: 'fas fa-plug',
        description: 'Customer Termination Box',
    },
    {
        id: 'Cabinet',
        label: 'Cabinet',
        icon: 'fas fa-server',
        description: 'Street cabinet or enclosure',
    },
];
/**
 * Modern React component for selecting structure type
 * Replaces legacy Bootstrap popup with consistent design system
 */
export const StructureTypeSelector = ({ structureTypes = DEFAULT_STRUCTURE_TYPES, onSelectType, onBack, onRemove, onClose, }) => {
    return (_jsxs("div", { className: "structure-type-selector", children: [_jsxs("div", { className: "structure-type-selector__header", children: [_jsx("div", { className: "structure-type-selector__icon", children: _jsx("i", { className: "fas fa-draw-polygon" }) }), _jsxs("div", { className: "structure-type-selector__title", children: [_jsx("h3", { children: "New Structure Type" }), _jsx("p", { className: "structure-type-selector__subtitle", children: "Select the type of structure to create" })] })] }), _jsx("div", { className: "structure-type-selector__types", children: structureTypes.map((type) => (_jsxs("button", { type: "button", className: "structure-type-selector__type-btn", onClick: () => onSelectType(type.id), title: type.description, children: [_jsx("i", { className: type.icon }), _jsx("span", { children: type.label })] }, type.id))) }), _jsxs("div", { className: "structure-type-selector__footer", children: [onBack && (_jsxs("button", { type: "button", className: "structure-type-selector__footer-btn structure-type-selector__footer-btn--secondary", onClick: onBack, children: [_jsx("i", { className: "fas fa-arrow-left" }), _jsx("span", { children: "Back" })] })), _jsxs("button", { type: "button", className: "structure-type-selector__footer-btn structure-type-selector__footer-btn--danger", onClick: onRemove, children: [_jsx("i", { className: "fas fa-times" }), _jsx("span", { children: "Remove" })] })] })] }));
};
